export const FETCH_CRYPTO_SERVICES_LIST = 'CRYPTO/FETCH_CRYPTO_SERVICES_LIST';
export const FETCH_CRYPTO_SERVICES_LIST_ERROR = 'CRYPTO/FETCH_CRYPTO_SERVICES_LIST_ERROR';
export const CLEAR_FETCH_CRYPTO_SERVICES_LIST = 'CRYPTO/CLEAR_FETCH_CRYPTO_SERVICES_LIST';

export const FETCH_CRYPTO_LINKS_LIST = 'CRYPTO/FETCH_CRYPTO_LINKS_LIST';
export const FETCH_CRYPTO_LINKS_LIST_ERROR = 'CRYPTO/FETCH_CRYPTO_LINKS_LIST_ERROR';
export const CLEAR_FETCH_CRYPTO_LINKS_LIST = 'CRYPTO/CLEAR_FETCH_CRYPTO_LINKS_LIST';

export const APPLY_CRYPTO_LINK_DRAG = 'CRYPTO/APPLY_CRYPTO_LINK_DRAG';
export const APPLY_CRYPTO_LINK_DRAG_ERROR = 'CRYPTO/APPLY_CRYPTO_LINK_DRAG_ERROR';
export const CLEAR_CRYPTO_LINK_DRAG = 'CRYPTO/CLEAR_CRYPTO_LINK_DRAG';

export const CREATE_CRYPTO_LINK_SUCCESS = 'CRYPTO/CREATE_CRYPTO_LINK_SUCCESS';
export const CREATE_CRYPTO_LINK_ERROR = 'CRYPTO/CREATE_CRYPTO_LINK_ERROR';
export const CLEAR_CREATE_CRYPTO_LINK = 'CRYPTO/CLEAR_CREATE_CRYPTO_LINK';

export const PATCH_CRYPTO_LINK_SUCCESS = 'CRYPTO/PATCH_CRYPTO_LINK_SUCCESS';
export const PATCH_CRYPTO_LINK_ERROR = 'CRYPTO/PATCH_CRYPTO_LINK_ERROR';
export const CLEAR_PATCH_CRYPTO_LINK = 'CRYPTO/CLEAR_PATCH_CRYPTO_LINK';

export const DELETE_CRYPTO_LINK_SUCCESS = 'CRYPTO/DELETE_CRYPTO_LINK_SUCCESS';
export const DELETE_CRYPTO_LINK_ERROR = 'CRYPTO/DELETE_CRYPTO_LINK_ERROR';
export const CLEAR_DELETE_CRYPTO_LINK = 'CRYPTO/CLEAR_DELETE_CRYPTO_LINK';
